import React from 'react';

import { Link } from "react-router-dom";
import PropTypes from 'prop-types'; 

import {
  Career01,
  subkat

} from "../imagepath";

function SubKatChard(props) {
    return (
        <div className="col-md-6">
          {/* Row alignment */}
            
              <div className="student-list flex-fill">
                <div className="student-img">
                  <Link to={`/parameter-uji/${props.id}`}>
                    <img
                      className="img-fluid"
                      alt=""
                      src={subkat}
                    />
                  </Link>
                </div>
                <div className="student-content">
                  <h5>
                    <Link to={`/parameter-uji/${props.id}`} >{props.title}</Link>
                  </h5>
                  <h6>{props.header}</h6>
                  <div className="student-info">
                    <div className="loc-blk d-flex justify-content-center">
                      <img src={Career01} style={{width:'20px'}} className="me-1" alt="" />
                      <p>{props.parameter} Parameter</p>
                    </div>
                    
                  </div>
                </div>
              </div>
          {/* Row alignment */}
        </div>
    );
}
SubKatChard.propTypes = {
  title: PropTypes.string.isRequired, // Define title as required string
  header: PropTypes.string.isRequired, // Define title as required string
  id: PropTypes.number.isRequired, // Define title as required string
  parameter: PropTypes.number.isRequired, // Define title as required string
};
export default SubKatChard;